import { render, staticRenderFns } from "./PlayerActive.vue?vue&type=template&id=4c8dcfbe"
import script from "./PlayerActive.vue?vue&type=script&lang=js"
export * from "./PlayerActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports